import styled from 'styled-components';

export const CatalogContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.gray8};
  padding-top: 0.5rem;

  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

export const Sidebar = styled.div`
  display: block;
  width: 342px;
  margin-bottom: 1.5rem;
  padding: 1.5rem;
  background-color: ${({ theme }) => theme.colors.white4};

  @media (max-width: 992px) {
    width: 100%;
    padding: 1.5rem;
    display: block;
  }
`;

export const ProductContainer = styled.div`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-bottom: 1.5rem;
  width: 100%;
`;
